export { default } from './TableSortLabel';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/TableSortLabel/index.js
// module id = 857
// module chunks = 2